var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('category-list',{model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}}),_c('course-list',{attrs:{"courses":_vm.allCourses,"filters":_vm.filters}}),_c('main-page-institute-list'),_c('faq-list'),_c('feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }